import React, { Component } from 'react'
import { connect } from 'react-redux'
import { filter } from 'helpers/decorators'
import { Input } from 'components/fields'
import { Module, Row, Col, FilterActions } from 'components/misc'
import { assessors as assessorsApi } from 'redux/modules/api'

@connect(
  ({ api }) => ({
    query: api.assessors.registrations.filter,
    count: api.assessors.registrations.count
  }),
  { setFilter: assessorsApi.setRegistrationFilter }
)
@filter({
  form: 'assessor-registrations-filter',
  persist: true
})
class FilterAssessorRegistrations extends Component {
  render() {
    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              name="assessor_person_id||assessor_person_name||assessor_person_email||activity_award_participant_firstName||activity_award_participant_middleName||activity_award_participant_lastName@ic"
              intlKey="label.search"
              clearable
            />
          </Col>
          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} />
          </Col>
        </Row>
      </Module>
    )
  }
}

export default FilterAssessorRegistrations
